export default __webpack_public_path__ + "static/media/person-black.b3949029.svg";